import React from 'react';
import { TimePicker } from '@material-ui/pickers';
import { TextField } from '@material-ui/core';
import moment from '../../moment-hawaii';

const PriceRuleTimeRange = ({ value, setValue, label, format }) => (
    <div style={{ display: 'flex', flexWrap: 'wrap' }}>
        {value.map((val, key) => (
            <TimePicker
                key={key}
                variant="inline"
                style={{ marginRight: '0.5rem' }}
                label={label}
                ampm={false}
                autoOk
                value={moment(val, format)}
                onChange={time =>
                    setValue(value.map((t, k) => (k === key ? time.format(format) : t)))
                }
                renderInput={props => <TextField {...props} helperText={null} />}
            />
        ))}
    </div>
);

export default PriceRuleTimeRange;
